export default [
    {
		code: 'Active',
		name: 'Active',
	}, 
	{
		code: 'Inactive',
		name: 'Inactive',
	}, 
];